import dataServices from "../../services/DataServices";
import { addItem, getAllItems} from '../../services/StreamingDBService';
import { sharepointImg, crossImg } from "../../images/ImageResolver";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function fetchData(tabName){
  async function fetchData(uri){
    let url = API_BASE_URL + uri;
    return dataServices.sendGetRequest(url);
  }

  async function fetchAllData(nextPageKey=null){
    let uri = `get-data?tab=${tabName}&limit=300`;
    if(nextPageKey){
      uri += `&nextPageKey=${nextPageKey}`;
    }
    const res = await fetchData(uri);
    await addItem(tabName, res.data.items);
    if(res.data.hasMore){
      return await fetchAllData(res.data.nextPageKey["content"]);
    }
    return res.data.items;
  }

  const fetchDataAsync = async () => {
    let allData = await getAllItems(tabName);
    if(allData && allData.length > 0){
      return allData;
    }else{
      await fetchAllData();
      return await getAllItems(tabName);
    }
  }
  return await fetchDataAsync()
}

export function cellWithMultipleLines(e) {
  let cell = e.cell;
  var field = e.field;
  var data = e.rowData[field];
  let content = cell.getContent();
  if(!content || !content._myCellWithMultipleLines) {
    content = document.createElement("div");
    content._myCellWithMultipleLines = true;
    let span = content._span = document.createElement("span");
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    content.appendChild(span);
  }
  content._span.textContent = data;
  try {
    cell.setTooltip(data);
  } catch (error) {
    console.error('Error setting tooltip:', error);
  }
  cell.setContent(content);
}

export function textwithImg(e){
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myTextWithImg) {
    content = document.createElement("div");
    content._myTextWithImg = true;
    let link = content._link = document.createElement("a");
    link.href = e.data;
    link.target = "_blank";
    link.style.cursor = "pointer";
    link.style.textAlign = "center";
    link.style.display = "block";
    link.style.width = "100%";
    content.appendChild(link);
    let img = content._img = document.createElement("img");
    img.style.width = "28px";
    img.style.height = "28px";
    img.style.verticalAlign = "middle";
    img.style.cursor = "pointer";
    content._link.appendChild(img);
    content.appendChild(content._link);
  }
  if(e.data !== null && e.data !== undefined && e.data !== ""){
    content._link.href = e.data;
    content._link.style.pointerEvents = "auto";
    content._img.src = sharepointImg;
  }else{
    content._link.href = "#";
    content._link.style.pointerEvents = "none";
    content._img.src = crossImg;
  }
  try {
    if(e.data !== null && e.data !== undefined && e.data !== ""){
      cell.setTooltip(e.data);
    }else{
      cell.setTooltip("No reference document");
    }
  } catch (error) {
    console.error('Error setting tooltip:', error);
  }
  cell.setContent(content);
}

export function renderPreText(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myRenderPreText) {
    content = document.createElement("div");
    content._myRenderPreText = true;
    let span = content._span = document.createElement("span");
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    content.appendChild(span);
  }
  content._span.textContent = e.data;
  content.title = e.data;
  cell.setContent(content);
}


